import { useState } from "react";
import { StickyNote, Save, History } from "lucide-react";

export function BookingNotes({ booking, history, onSave }) {
  const [notes, setNotes] = useState(booking.admin_notes || "");
  const [busy, setBusy] = useState(false);
  const dirty = notes !== (booking.admin_notes || "");
  const save = async () => { setBusy(true); try { await onSave(booking.booking_id, notes); } finally { setBusy(false); } };

  return (
    <div className="mt-4 grid gap-4 md:grid-cols-2" data-testid={`booking-notes-${booking.booking_id}`}>
      <div>
        <div className="dg-eyebrow mb-1 flex items-center gap-1"><StickyNote className="w-3 h-3" /> Private notes (only you see these)</div>
        <textarea className="dg-input min-h-[80px] text-sm" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="What you fixed, model numbers, passwords hints, follow-ups…" data-testid={`notes-input-${booking.booking_id}`} />
        <div className="mt-2 flex items-center gap-3">
          <button type="button" onClick={save} disabled={!dirty || busy} className="dg-btn-primary rounded-full px-4 py-1.5 text-xs flex items-center gap-1.5 disabled:opacity-40" data-testid={`notes-save-${booking.booking_id}`}>
            <Save className="w-3 h-3" /> {busy ? "Saving…" : "Save note"}
          </button>
          {booking.admin_notes_at && !dirty && <span className="text-[11px] text-slate-500">Saved {new Date(booking.admin_notes_at).toLocaleDateString()}</span>}
        </div>
      </div>
      <div>
        <div className="dg-eyebrow mb-1 flex items-center gap-1"><History className="w-3 h-3" /> Past sessions with {booking.name?.split(" ")[0] || "this customer"}</div>
        {history.length === 0 ? <div className="text-xs text-slate-500">First session with this customer.</div> : (
          <ul className="space-y-2 text-xs" data-testid={`history-${booking.booking_id}`}>
            {history.map((h) => (
              <li key={h.booking_id} className="rounded-lg border border-slate-800 bg-slate-900/40 p-2.5">
                <div className="text-slate-300">{new Date(h.scheduled_at).toLocaleDateString()} · {h.service_name} <span className="text-slate-500">· {h.status.replace("_", " ")}</span></div>
                {h.admin_notes ? <div className="text-slate-400 mt-1 whitespace-pre-wrap">{h.admin_notes}</div> : <div className="text-slate-600 mt-1 italic">No notes</div>}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
